/* eslint-disable react/jsx-indent */
/* eslint-disable import/no-unresolved */
import axios from 'axios';
import { saveAs } from 'file-saver';

import {
    doneUploadingVar, getPreviousBatchVar, isFileUploadingVar, showBatchAlertVar,
} from 'Apollo/config';
import { getAuthorizationHeaderValue, getAccessToken, getProfile } from 'views/Auth/AuthHelper';
import { ContentTypeEnum } from '../constants/index';

export const baseLink = process.env.REACT_APP_BASE_LINK;

export const downloadFRY7QTemplate = async template => {
    try {
        const token = getAuthorizationHeaderValue();
        const url = `${baseLink}api/rules/downloadReportTemplateForFRY7Q`;
        const body = {
            templateName: template,
        };
        const response = await axios.post(url, body, {
            headers: {
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        const { data } = response;
        const updatedData = new Blob([data], { type: 'text/csv' });
        saveAs(updatedData, 'FR_Y7Q_template.csv');
    } catch (e) {
        //
    }
};

export const downloadFRY9CTemplate = async template => {
    try {
        const token = getAuthorizationHeaderValue();
        const url = `${baseLink}api/rules/downloadReportTemplate`;
        const body = {
            templateName: template,
            regulatorName: 'fry9c',
        };
        const response = await axios.post(url, body, {
            headers: {
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        const { data } = response;
        const updatedData = new Blob([data], { type: 'text/csv' });
        saveAs(updatedData, 'FR_Y9C_template.csv');
    } catch (e) {
        //
    }
};

export const downloadFFIEC031Template = async template => {
    try {
        const token = getAuthorizationHeaderValue();
        const url = `${baseLink}api/rules/downloadReportTemplate`;
        const body = {
            templateName: template,
            regulatorName: 'ffiec031',
        };
        const response = await axios.post(url, body, {
            headers: {
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        const { data } = response;
        const updatedData = new Blob([data], { type: 'text/csv' });
        saveAs(updatedData, 'FFIEC_031_template.csv');
    } catch (e) {
        //
    }
};

export const downloadFFIEC041Template = async template => {
    try {
        const token = getAuthorizationHeaderValue();
        const url = `${baseLink}api/rules/downloadReportTemplate`;
        const body = {
            templateName: template,
            regulatorName: 'ffiec041',
        };
        const response = await axios.post(url, body, {
            headers: {
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        const { data } = response;
        const updatedData = new Blob([data], { type: 'text/csv' });
        saveAs(updatedData, 'FFIEC_041_template.csv');
    } catch (e) {
        //
    }
};

export const downloadMetro2Template = async () => {
    try {
        const token = getAuthorizationHeaderValue();
        const url = `${baseLink}api/rules/downloadReportTemplateForMETRO2`;
        const response = await axios.get(url, {
            headers: {
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        const { data } = response;
        const updatedData = new Blob([data], { type: 'text/txt' });
        saveAs(updatedData, 'Metro2_template.txt');
    } catch (e) {
        //
    }
};

export const downloadFFIEC009Template = async () => {
    try {
        const token = getAuthorizationHeaderValue();
        const url = `${baseLink}api/rules/downloadReportTemplateForFFIEC009`;
        const response = await axios.get(url, {
            responseType: 'arraybuffer',
            headers: {
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        const { data } = response;
        const updatedData = new Blob([data], { type: response.headers['content-type'] });
        saveAs(updatedData, 'FFIEC009_template.xlsm');
    } catch (e) {
        //
    }
};

export const downloadFR2052ATemplate = async () => {
    try {
        const token = getAuthorizationHeaderValue();
        const url = `${baseLink}api/rules/downloadReportTemplateForFR2052A`;
        const response = await axios.get(url, {
            responseType: 'arraybuffer',
            headers: {
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        const { data } = response;
        const updatedData = new Blob([data], { type: response.headers['content-type'] });
        saveAs(updatedData, 'FR2052A_template.csv');
    } catch (e) {
        //
    }
};

export const uploadFRY7QData = async payload => {
    const token = getAuthorizationHeaderValue();
    const {
        regulatorName, period, topTierFlag, files,
        tenantId,
    } = payload;
    const fd = new FormData();
    fd.append('regulatorName', regulatorName);
    fd.append('period', period);
    fd.append('topTierFlag', topTierFlag);
    fd.append('files', files);
    fd.append('tenantId', tenantId);
    doneUploadingVar(true);
    try {
        isFileUploadingVar(true);
        const url = `${baseLink}api/rules/uploadReportFRY7Q`;
        await axios.post(url, fd, {
            headers: {
                'Content-Type': ContentTypeEnum.MULTIPART,
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        await new Promise(r => setTimeout(r, 10000));
        getPreviousBatchVar(true);
        showBatchAlertVar(true);
        doneUploadingVar(false);
        isFileUploadingVar(false);
    } catch (e) {
        doneUploadingVar(false);
    }
};

export const uploadFRY9CData = async payload => {
    const token = getAuthorizationHeaderValue();
    const {
        regulatorName, period, files,
        tenantId, institution,
        finalRuleOnly,
        advanced,
        nonAdvanced,
        grandFathered,
        foreignGsib,
        topTierBhc,
        exitParallel,
        cat3Hc,
        noCblrOnly,
        cat123Only,
    } = payload;
    const fd = new FormData();
    fd.append('regulatorName', regulatorName);
    fd.append('period', period);
    fd.append('files', files);
    fd.append('tenantId', tenantId);
    fd.append('institution', institution);
    fd.append('finalRuleOnly', finalRuleOnly);
    fd.append('advanced', advanced);
    fd.append('nonAdvanced', nonAdvanced);
    fd.append('grandfathered', grandFathered);
    fd.append('foreignGsib', foreignGsib);
    fd.append('topTierBhc', topTierBhc);
    fd.append('exitParallel', exitParallel);
    fd.append('cat3Hc', cat3Hc);
    fd.append('noCblrOnly', noCblrOnly);
    fd.append('cat123Only', cat123Only);
    doneUploadingVar(true);
    try {
        isFileUploadingVar(true);
        const url = `${baseLink}api/rules/uploadReportFRY9C`;
        await axios.post(url, fd, {
            headers: {
                'Content-Type': ContentTypeEnum.MULTIPART,
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        await new Promise(r => setTimeout(r, 10000));
        getPreviousBatchVar(true);
        showBatchAlertVar(true);
        doneUploadingVar(false);
        isFileUploadingVar(false);
    } catch (e) {
        doneUploadingVar(false);
    }
};

export const uploadFFIEC031Data = async payload => {
    const token = getAuthorizationHeaderValue();
    const {
        regulatorName, period, files,
        tenantId, institution,
        finalRuleOnly,
        advanced,
        nonAdvanced,
        exitParallel,
        cat3Hc,
        noCblrOnly,
    } = payload;
    const fd = new FormData();
    fd.append('regulatorName', regulatorName);
    fd.append('period', period);
    fd.append('files', files);
    fd.append('tenantId', tenantId);
    fd.append('institution', institution);
    fd.append('finalRuleOnly', finalRuleOnly);
    fd.append('advanced', advanced);
    fd.append('nonAdvanced', nonAdvanced);
    fd.append('exitParallel', exitParallel);
    fd.append('cat3Hc', cat3Hc);
    fd.append('noCblrOnly', noCblrOnly);
    doneUploadingVar(true);
    try {
        isFileUploadingVar(true);
        const url = `${baseLink}api/rules/uploadReportFFIEC031`;
        await axios.post(url, fd, {
            headers: {
                'Content-Type': ContentTypeEnum.MULTIPART,
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        await new Promise(r => setTimeout(r, 10000));
        getPreviousBatchVar(true);
        showBatchAlertVar(true);
        doneUploadingVar(false);
        isFileUploadingVar(false);
    } catch (e) {
        doneUploadingVar(false);
    }
};

export const uploadFFIEC041Data = async payload => {
    const token = getAuthorizationHeaderValue();
    const {
        regulatorName, period, files,
        tenantId, institution,
        finalRuleOnly,
        nonAdvanced,
        cat3Hc,
        noCblrOnly,
    } = payload;
    const fd = new FormData();
    fd.append('regulatorName', regulatorName);
    fd.append('period', period);
    fd.append('files', files);
    fd.append('tenantId', tenantId);
    fd.append('institution', institution);
    fd.append('finalRuleOnly', finalRuleOnly);
    fd.append('nonAdvanced', nonAdvanced);
    fd.append('cat3Hc', cat3Hc);
    fd.append('noCblrOnly', noCblrOnly);
    doneUploadingVar(true);
    try {
        isFileUploadingVar(true);
        const url = `${baseLink}api/rules/uploadReportFFIEc041`;
        await axios.post(url, fd, {
            headers: {
                'Content-Type': ContentTypeEnum.MULTIPART,
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        await new Promise(r => setTimeout(r, 10000));
        getPreviousBatchVar(true);
        showBatchAlertVar(true);
        doneUploadingVar(false);
        isFileUploadingVar(false);
    } catch (e) {
        doneUploadingVar(false);
    }
};

export const uploadMetro2Data = async payload => {
    const token = getAuthorizationHeaderValue();
    const {
        regulatorName, files, tenantId, period,
    } = payload;
    const profile = getProfile();
    const fd = new FormData();
    fd.append('regulatorName', regulatorName);
    fd.append('files', files);
    fd.append('tenantId', tenantId);
    fd.append('iamUserId', profile.userId);
    fd.append('period', period);
    doneUploadingVar(true);
    try {
        isFileUploadingVar(true);
        const url = `${baseLink}api/rules/uploadReportMETRO2`;
        await axios.post(url, fd, {
            headers: {
                'Content-Type': ContentTypeEnum.MULTIPART,
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        await new Promise(r => setTimeout(r, 10000));
        getPreviousBatchVar(true);
        showBatchAlertVar(true);
        doneUploadingVar(false);
        isFileUploadingVar(false);
    } catch (e) {
        doneUploadingVar(false);
    }
};

export const uploadFFIEC009Data = async payload => {
    const token = getAuthorizationHeaderValue();
    const {
        regulatorName, files, period, tenantId,
    } = payload;
    const fd = new FormData();
    fd.append('regulatorName', regulatorName);
    fd.append('period', period);
    fd.append('files', files);
    fd.append('tenantId', tenantId);
    doneUploadingVar(true);
    try {
        isFileUploadingVar(true);
        const url = `${baseLink}api/rules/uploadReportFFIEC009`;
        await axios.post(url, fd, {
            headers: {
                'Content-Type': ContentTypeEnum.MULTIPART,
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        await new Promise(r => setTimeout(r, 10000));
        doneUploadingVar(false);
        isFileUploadingVar(false);
        getPreviousBatchVar(true);
        showBatchAlertVar(true);
    } catch (e) {
        doneUploadingVar(false);
    }
};

export const uploadFR2052AData = async payload => {
    const token = getAuthorizationHeaderValue();
    const {
        regulatorName, files, period, tenantId,
    } = payload;
    const fd = new FormData();
    fd.append('regulatorName', regulatorName);
    fd.append('period', period);
    fd.append('files', files);
    fd.append('tenantId', tenantId);
    doneUploadingVar(true);
    try {
        isFileUploadingVar(true);
        const url = `${baseLink}api/rules/uploadReportFR2052A`;
        await axios.post(url, fd, {
            headers: {
                'Content-Type': ContentTypeEnum.MULTIPART,
                authorization: token ? `Bearer ${token}` : '',
                token: getAccessToken(),
                'x-isRestAPI': true,
            },
        });
        await new Promise(r => setTimeout(r, 10000));
        getPreviousBatchVar(true);
        showBatchAlertVar(true);
        doneUploadingVar(false);
        isFileUploadingVar(false);
    } catch (e) {
        doneUploadingVar(false);
    }
};
